/**
 * <drip-countdown data-end="YYYY-MM-DD HH:MM">
 * Ticks down to the given date/time (parsed in the visitor's local time zone)
 * and writes the remaining days/hours/minutes/seconds into child elements
 * marked with data-unit="days|hours|minutes|seconds". Freezes at zero and
 * adds an "is-expired" class when the target time has passed.
 */
class DripCountdown extends HTMLElement {
  connectedCallback() {
    const raw = this.dataset.end;
    if (!raw) return;

    // Safari/older engines don't reliably parse "YYYY-MM-DD HH:MM"; swap the
    // space for a "T" so it's treated as a local-time ISO string everywhere.
    this.target = new Date(raw.replace(' ', 'T'));
    if (Number.isNaN(this.target.getTime())) return;

    this.units = {
      days: this.querySelector('[data-unit="days"]'),
      hours: this.querySelector('[data-unit="hours"]'),
      minutes: this.querySelector('[data-unit="minutes"]'),
      seconds: this.querySelector('[data-unit="seconds"]'),
    };

    this.tick();
    this.timer = window.setInterval(() => this.tick(), 1000);
  }

  tick() {
    const remainingMs = this.target.getTime() - Date.now();

    if (remainingMs <= 0) {
      this.render(0, 0, 0, 0);
      this.classList.add('is-expired');
      window.clearInterval(this.timer);
      return;
    }

    const totalSeconds = Math.floor(remainingMs / 1000);
    const days = Math.floor(totalSeconds / 86400);
    const hours = Math.floor((totalSeconds % 86400) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    this.render(days, hours, minutes, seconds);
  }

  render(days, hours, minutes, seconds) {
    const pad = (value) => String(value).padStart(2, '0');
    if (this.units.days) this.units.days.textContent = pad(days);
    if (this.units.hours) this.units.hours.textContent = pad(hours);
    if (this.units.minutes) this.units.minutes.textContent = pad(minutes);
    if (this.units.seconds) this.units.seconds.textContent = pad(seconds);
  }

  disconnectedCallback() {
    window.clearInterval(this.timer);
  }
}

customElements.define('drip-countdown', DripCountdown);
